/**
 * TECHNECK Theme JS — Cart drawer, sticky buy bar, FAQ, animations
 */
(function() {
  'use strict';
  if (window.__TN_THEME_JS__) return;
  window.__TN_THEME_JS__ = true;

  // ===== SCROLL REVEAL =====
  function initScrollReveal() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.tn-reveal').forEach(function(el) { observer.observe(el); });
    // Fallback: make everything visible after 2s
    setTimeout(function() {
      document.querySelectorAll('.tn-reveal').forEach(function(el) { el.classList.add('visible'); });
    }, 2000);
  }

  // ===== FAQ ACCORDION =====
  function initFAQ() {
    document.querySelectorAll('.tn-faq__q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.tn-faq__item');
        var wasOpen = item.classList.contains('open');
        document.querySelectorAll('.tn-faq__item').forEach(function(i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  // ===== CART DRAWER =====
  function initCartDrawer() {
    var drawer = document.querySelector('.tn-cart-drawer');
    if (!drawer) return;
    var overlay = drawer.querySelector('.tn-cart-drawer__overlay');
    var closeBtn = drawer.querySelector('.tn-cart-drawer__close');
    var openBtns = document.querySelectorAll('[data-cart-open]');

    function open() { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; fetchCart(); }
    function close() { drawer.classList.remove('open'); document.body.style.overflow = ''; }

    openBtns.forEach(function(btn) { btn.addEventListener('click', function(e) { e.preventDefault(); open(); }); });
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
  }

  function fetchCart() {
    fetch('/cart.js', { credentials: 'include' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function() {});
  }

  function renderCart(cart) {
    var body = document.querySelector('.tn-cart-drawer__body');
    var footer = document.querySelector('.tn-cart-drawer__footer');
    var count = document.querySelector('[data-cart-count]');
    if (count) count.textContent = cart.item_count || 0;

    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="tn-cart-empty"><p>Your cart is empty.</p><a href="/products/techneck-reset-heat" class="tn-btn tn-btn--primary">Shop TECHNECK</a></div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    var html = cart.items.map(function(item) {
      return '<div class="tn-cart-item" data-key="' + item.key + '">' +
        '<img class="tn-cart-item__img" src="' + item.image + '&width=120" alt="' + item.title + '" width="60" height="60">' +
        '<div class="tn-cart-item__info">' +
          '<div class="tn-cart-item__title">' + item.product_title + '</div>' +
          '<div class="tn-cart-item__variant">' + item.variant_title + '</div>' +
          '<div class="tn-cart-item__price">$' + (item.price / 100).toFixed(2) + '</div>' +
        '</div>' +
        '<div class="tn-cart-item__qty">' +
          '<button class="tn-qty-btn" data-action="dec" data-key="' + item.key + '">−</button>' +
          '<span class="tn-qty-val">' + item.quantity + '</span>' +
          '<button class="tn-qty-btn" data-action="inc" data-key="' + item.key + '">+</button>' +
        '</div>' +
        '<button class="tn-cart-item__remove" data-key="' + item.key + '">Remove</button>' +
      '</div>';
    }).join('');
    body.innerHTML = html;

    if (footer) {
      footer.style.display = 'block';
      footer.querySelector('.tn-cart-drawer__subtotal').textContent = '$' + (cart.total_price / 100).toFixed(2);
    }

    // Wire up quantity buttons
    body.querySelectorAll('.tn-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        var action = btn.getAttribute('data-action');
        var item = cart.items.find(function(i) { return i.key === key; });
        if (!item) return;
        var qty = action === 'inc' ? item.quantity + 1 : item.quantity - 1;
        updateCart(key, qty);
      });
    });

    // Wire up remove buttons
    body.querySelectorAll('.tn-cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        updateCart(key, 0);
      });
    });
  }

  function updateCart(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }), credentials: 'include'
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function() {});
  }

  // ===== ADD TO CART (AJAX) =====
  function initAddToCart() {
    document.querySelectorAll('form[data-product-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        // Show loading state on button
        var btn = form.querySelector('.tn-product__add');
        var btnText = form.querySelector('.tn-product__add-text');
        var originalText = btnText ? btnText.textContent : '';
        if(btnText){ btnText.textContent = 'Adding...'; }
        if(btn){ btn.style.opacity = '0.7'; btn.disabled = true; }
        // Let the form submit normally (no preventDefault)
        // This ensures the cart always works — form POSTs to /cart/add and redirects to /cart
      });
    });
  }

  function initStickyBuyBar() {
    var bar = document.querySelector('.tn-sticky-buy');
    var buyBox = document.querySelector('[data-buy-box]');
    if (!bar || !buyBox) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          bar.classList.add('show');
        } else {
          bar.classList.remove('show');
        }
      });
    }, { threshold: 0 });

    observer.observe(buyBox);
  }

  // ===== SMOOTH SCROLL =====
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // ===== VARIANT PRICE UPDATE =====
  function initVariantSelector() {
    var selects = document.querySelectorAll('select[name="id"]');
    selects.forEach(function(select) {
      select.addEventListener('change', function() {
        var variantId = select.value;
        var priceEl = document.querySelector('[data-variant-price]');
        var compareEl = document.querySelector('[data-variant-compare]');
        var btn = document.querySelector('[data-buy-price]');

        // Fetch variant data
        fetch('/products/techneck-reset-heat.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            var variant = product.variants.find(function(v) { return v.id == variantId; });
            if (!variant) return;
            if (priceEl) priceEl.textContent = '$' + variant.price;
            if (compareEl && variant.compare_at_price) compareEl.textContent = '$' + variant.compare_at_price;
            if (btn) btn.textContent = 'Add to cart — $' + variant.price;
          })
          .catch(function() {});
      });
    });
  }

  // ===== INIT =====
  function init() {
    initScrollReveal();
    initFAQ();
    initCartDrawer();
    initAddToCart();
    initStickyBuyBar();
    initSmoothScroll();
    initVariantSelector();

    // Fetch initial cart count
    fetch('/cart.js', { credentials: 'include' })
      .then(function(r) { return r.json(); })
      .then(function(c) {
        var count = document.querySelector('[data-cart-count]');
        if (count) count.textContent = c.item_count || 0;
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// cache-bust: 1787555355.2255123
